var map = {
	"./3d.svg": 89005,
	"./accessory.svg": 53048,
	"./account-add.svg": 22131,
	"./account-admin.svg": 50550,
	"./account-edit.svg": 10559,
	"./account.svg": 76107,
	"./backup.svg": 57479,
	"./category.svg": 56406,
	"./close.svg": 97990,
	"./company.svg": 32543,
	"./company_1.svg": 40141,
	"./conf.svg": 23853,
	"./config-file.svg": 25441,
	"./corpus.svg": 16421,
	"./dashboard.svg": 4140,
	"./dict.svg": 76554,
	"./dislike.svg": 40312,
	"./document-mng.svg": 28763,
	"./document.svg": 84151,
	"./electric.svg": 13450,
	"./email.svg": 29460,
	"./erp.svg": 76260,
	"./exchange.svg": 63332,
	"./expand.svg": 40961,
	"./global.svg": 7794,
	"./goods_type.svg": 78277,
	"./group-mng.svg": 55640,
	"./group.svg": 60083,
	"./history.svg": 27018,
	"./home.svg": 58502,
	"./inout.svg": 58615,
	"./key.svg": 5178,
	"./letter-send.svg": 70808,
	"./letter.svg": 98788,
	"./like.svg": 92304,
	"./lock.svg": 63099,
	"./log.svg": 46045,
	"./log2.svg": 64862,
	"./menu.svg": 66498,
	"./menu1.svg": 41603,
	"./message.svg": 85620,
	"./model.svg": 46568,
	"./msg-setting.svg": 84468,
	"./msg-wechat.svg": 96108,
	"./notice.svg": 71959,
	"./order.svg": 64047,
	"./oss.svg": 62293,
	"./phmsg.svg": 37585,
	"./private.svg": 29787,
	"./product.svg": 49462,
	"./production1.svg": 75747,
	"./production2.svg": 56008,
	"./purchase.svg": 89706,
	"./question.svg": 42946,
	"./quickrp.svg": 33134,
	"./rag.svg": 83228,
	"./read.svg": 92249,
	"./relation.svg": 38660,
	"./repair-manage.svg": 12441,
	"./repair.svg": 98250,
	"./reply.svg": 35059,
	"./reply_1.svg": 95295,
	"./responses.svg": 63948,
	"./return.svg": 16891,
	"./revoke.svg": 72773,
	"./rule-add.svg": 38872,
	"./setting.svg": 27015,
	"./signal.svg": 52553,
	"./stat.svg": 96701,
	"./stock-mng.svg": 55069,
	"./stock.svg": 68418,
	"./stock2.svg": 31740,
	"./system.svg": 82755,
	"./template-email.svg": 86571,
	"./test.svg": 76317,
	"./tool.svg": 8992,
	"./track.svg": 40782,
	"./type.svg": 91428,
	"./unknown.svg": 30520,
	"./unread.svg": 98997,
	"./user.svg": 94638,
	"./userlog.svg": 13480,
	"./wifi.svg": 80377,
	"./workflow.svg": 71036,
	"./workflow_bucket.svg": 60507,
	"./workflow_progress.svg": 8325,
	"./workflow_type.svg": 61717,
	"./wx.svg": 70258,
	"./wxmp-conditional-menu.svg": 21882,
	"./wxmp-material.svg": 76372,
	"./wxmp-menu.svg": 90662,
	"./wxmsg.svg": 42945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63190;